export default {
  tinyPhone: '(max-width: 359px)',
  phone: '(max-width: 1023px)',
  desktop: '(min-width: 1024px)',
}
